import { render, staticRenderFns } from "./addExtendPt.vue?vue&type=template&id=041683a5&"
import script from "./addExtendPt.vue?vue&type=script&lang=js&"
export * from "./addExtendPt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports